<template>
    <div>
        <v-toolbar  
            flat
            :dense=dense
            style="height:85px;background:linear-gradient(0deg, rgba(80,201,149,1) 0%, rgba(97,192,151,1) 100%)"
            class="menu-fixed"
        >
            <v-row 
                align="center"
                justify="center"
                class='margin-menu'
                style="    position: relative;top: 20px;"
            >
                <v-col cols="12" md='2' class='text-center text-md-left'>
                    <a href="/"><v-img :src="`${require('@/assets/logo-blanco-innofarm.png')}`" width="150px" /></a>
                </v-col>
                <v-col cols="12" md="8">
                    <v-text-field
                        v-model=productText
                        placeholder="Busque su medicina o producto aquí"
                        outlined
                        single-line
                        dense
                        rounded
                        append-icon="mdi-magnify"
                        background-color="white"
                        flat
                        hide-details
                        id="input-index-search"
                        @keydown.enter="redirectShoppingCar"
                        @click:append="redirectShoppingCar"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md='2' class='text-center'>
                    <MiniShippingCarComponent />
                </v-col>
            </v-row>
        </v-toolbar>
        <v-col cols="12" class='text-center menu-link py-1'>
            <div class='margin-menu'>
                <router-link
                    to="/"
                    custom
                    v-slot="{ href, route, navigate, isActive, isExactActive }"
                >
                    
                    <v-btn depressed :ripple="false" color='transparent' class='link-menu text-capitalize' :active="isActive" :href="href" @click="navigate">
                        <v-icon>mdi-home-outline</v-icon> Inicio
                    </v-btn>
                </router-link>
                <router-link
                    to="/perfil-cliente"
                    custom
                    v-slot="{ href, route, navigate, isActive, isExactActive }"
                    v-if="loggedIn"
                >
                    <v-btn depressed :ripple="false" color='transparent' class='link-menu text-capitalize' :active="isActive" :href="href" @click="navigate" >
                        Perfil del cliente
                    </v-btn>
                </router-link>
                <router-link
                    to="/medicamentos-especialidad"
                    custom
                    v-slot="{ href, route, navigate, isActive, isExactActive }"
                >
                    <v-btn depressed :ripple="false" color='transparent' class='link-menu text-capitalize' :active="isActive" :href="href" @click="navigate">
                        Medicina de especialidad
                    </v-btn>
                </router-link>
                <!-- <router-link
                    to="/"
                    custom
                    v-slot="{ href, route, navigate, isActive, isExactActive }"
                >
                    <v-btn depressed :ripple="false" color='transparent' class='link-menu text-capitalize' :active="isActive" :href="href" @click="navigate">
                        Ayuda
                    </v-btn>
                </router-link> -->
                <v-divider
					class="mx-4"
					inset
					vertical
                    style="border-color:#4c4c4c"
				></v-divider>
                <router-link
                    to="/nosotros"
                    custom
                    v-slot="{ href, route, navigate, isActive, isExactActive }"
                >
                    <v-btn depressed :ripple="false" color='transparent' class='link-menu text-capitalize' :active="isActive" :href="href" @click="navigate">
                        Nosotros
                    </v-btn>
                </router-link>
                <router-link
                    to="/empresas_pymes"
                    custom
                    v-slot="{ href, route, navigate, isActive, isExactActive }"
                >
                    <v-btn depressed :ripple="false" color='transparent' class='link-menu text-capitalize' :active="isActive" :href="href" @click="navigate">
                        Corporativo
                    </v-btn>
                </router-link>
                <router-link
                    to="/sedes"
                    custom
                    v-slot="{ href, route, navigate, isActive, isExactActive }"
                >
                    <v-btn depressed :ripple="false" color='transparent' class='link-menu text-capitalize' :active="isActive" :href="href" @click="navigate">
                        Sedes
                    </v-btn>
                </router-link>
                <router-link
                    to="/contactos"
                    custom
                    v-slot="{ href, route, navigate, isActive, isExactActive }"
                >
                    <v-btn depressed :ripple="false" color='transparent' class='link-menu text-capitalize' :active="isActive" :href="href" @click="navigate">
                        Contactos
                    </v-btn>
                </router-link>
            </div>
        </v-col> 
    </div>
</template>

<script>

import {mapState, mapMutations} from 'vuex'
import MiniShippingCarComponent from '../partials/MiniShippingCarComponent'

export default {
    name: 'MenuComponent',
    components:{
        MiniShippingCarComponent,
        
    },
    data:()=>({
        menu:false,
        productText:null,
        show: false,
        user:'',
        password:'',
        requiredRule:[
            v => !!v || 'El campo es requerido'
        ],
    }),
    props:{

        dense:{
            type: Boolean,
            default: true
        },

        styleToolbar:{
            type: String,
            default: ''
        },

        styleRow:{
            type: String,
            default: ''
        }

    },
    computed:{

        ...mapState(['scrollTop','loggedIn'])

    },
    methods: {

        ...mapMutations(['setScrollTop']),

        redirectShoppingCar(){
            if(this.$route.params.search!=this.productText){
                if(this.productText!='' && this.productText != null)
                    this.$router.push(`/medicamentos-especialidad/${this.productText}`)
                else
                    this.$router.push('/medicamentos-especialidad')
            }
        },

        setScroll(){
            if((document.body.getBoundingClientRect()).top < 0){
              
               this.setScrollTop(false)

            }else{
                
                this.setScrollTop(true)

            }
        },

        loginClient(){
            
        }

    },
    created(){
        //this.setScroll()
    }
}

</script>

<style scope>

    .link-menu{
        font-size: 14px!important;
        font-family: Open Sans!important;
        color:#4c4c4c!important;
    }

    .margin-menu{
        margin-left: 120px!important;
        margin-right: 120px!important;
    }
  
    .menu-link{
        position: fixed;
        z-index: 9991;
        background: #e5e5e5;
        top: 134px;
    }

    .menu-fixed{
        position: fixed;
        width: 100%;
        top: 47px!important;
        z-index: 9991;
        height: 88px!important;
        background:linear-gradient(0deg, rgba(80,201,149,1) 0%, rgba(97,192,151,1) 100%);
    }

    .v-toolbar__content{
        height: 48px!important;
    }

    input#input-index-search::placeholder{
        font-style: italic!important;
        font-weight: 600;
    }

    @media (max-width: 1122px){

        .link-menu{
            padding: 0 6px!important;
        }
	}

    @media (max-width: 1000px){

        .link-menu{
            padding: 0 5px!important;
        }
	}

    @media (max-width: 985px){

        .link-menu{
            padding: 0 3px!important;
        }
	}

    @media (max-width: 985px){

        .link-menu{
            padding: 0 2px!important;
        }
	}

</style>